export default __webpack_public_path__ + "static/media/high.13ab83bd.png";